import { render, staticRenderFns } from "./TarifsProtectionJuridique.vue?vue&type=template&id=3b12b905&scoped=true&"
import script from "./TarifsProtectionJuridique.vue?vue&type=script&lang=js&"
export * from "./TarifsProtectionJuridique.vue?vue&type=script&lang=js&"
import style0 from "./TarifsProtectionJuridique.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./TarifsProtectionJuridique.vue?vue&type=style&index=1&id=3b12b905&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b12b905",
  null
  
)

export default component.exports